// Réseaux sociaux du club et des équipes (D-035) : on colle un lien, le réseau est
// reconnu. Mêmes règles que la base (social_links) : https, et le domaine du réseau.

export type Network = 'instagram' | 'facebook' | 'tiktok' | 'youtube' | 'x' | 'threads' | 'linkedin' | 'site';

export const NETWORK_LABEL: Record<Network, string> = {
  instagram: 'Instagram', facebook: 'Facebook', tiktok: 'TikTok', youtube: 'YouTube', x: 'X', threads: 'Threads', linkedin: 'LinkedIn', site: 'Site',
};

const PATTERNS: [Network, RegExp][] = [
  ['instagram', /^https:\/\/(www\.)?instagram\.com\//i],
  ['facebook', /^https:\/\/((www|m|web)\.)?(facebook\.com|fb\.com)\//i],
  ['tiktok', /^https:\/\/(www\.)?tiktok\.com\//i],
  ['youtube', /^https:\/\/((www|m)\.)?(youtube\.com|youtu\.be)\//i],
  ['x', /^https:\/\/(www\.)?(x\.com|twitter\.com)\//i],
  ['threads', /^https:\/\/(www\.)?threads\.(net|com)\//i],
  ['linkedin', /^https:\/\/([a-z]{2,3}\.)?linkedin\.com\//i],
];

/** « instagram.com/bcl » → « https://instagram.com/bcl » ; rien d'utilisable → null. */
export function normalizeUrl(input: string): string | null {
  let s = input.trim();
  if (!s || /\s/.test(s)) return null;
  if (/^http:\/\//i.test(s)) s = s.replace(/^http:/i, 'https:');
  if (!/^https:\/\//i.test(s)) s = `https://${s}`;
  return /^https:\/\/[^\s"'<>]+\.[^\s"'<>]+$/.test(s) && s.length <= 300 ? s : null;
}

/** Le réseau d'une adresse https (un site quelconque : « site »). */
export function detectNetwork(url: string): Network {
  return PATTERNS.find(([, re]) => re.test(url))?.[0] ?? 'site';
}
